import { Component, Input } from '@angular/core';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'se-flatpanel',
    templateUrl: './se-flatpanel.component.html',
    styleUrls: ['./se-flatpanel.component.less'],
    standalone: true,
    imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, NgClass, NgIf],
})
export class SeFlatPanelComponent {
    // data members

    @Input()
    title: string;

    @Input()
    isInternalPanel = false;
}
